import React from 'react'
import { useBlocker, useNavigate } from 'react-router-dom'
import { Button, Image } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
//
import ActionElements from '../../../components/extras/ActionElements'
import ModalX from '../../../components/others/ModalX'
import TicketDetails from '../pages/TicketDetails'
import { deletePaginationData } from '../../../store/actions/pagination'
import { PAGINATION_TYPES } from '../../../utils/constants'
import REST_API from '../../../services/API_Routes'
import { TicketsService } from '../../../services'
// import Communications from '../pages/Communications'
import MessageIcon from '../../../assets/icons/common/message.svg'
import TicketIcon from '../../../assets/icons/sidebar/ticket.svg'
import { CLASSES } from '../../../assets/styles/classes'
import Communications from '../../communications/Communications'
import { USER_ROLES } from '../../../utils/userRole'
import { TICKET_STATUS } from '../../../utils/static_data'

export default function TableAction({ data }) {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { user_role } = useSelector(({ auth }) => auth)
  const [isOpen, setIsOpen] = React.useState(false)
  const [isChatOpen, setIsChatOpen] = React.useState(false)

  const handleDelete = (id) => {
    dispatch(
      deletePaginationData({
        id,
        key: PAGINATION_TYPES.TICKETS,
        ServiceName: TicketsService,
        route: REST_API.TICKET_DELETE,
        primaryKey: 'ticket_id',
        delete_key: 'ticket_id',
        value: {
          ticket_id: id,
          ticket_active: 0,
        },
      }),
    )
  }

  const canAccess = user_role === USER_ROLES.ADMIN

  return (
    <>
      <div className='d-flex'>
        <ActionElements
          id={data.ticket_id}
          editClick={
            canAccess
              ? (id) => navigate(`/ticket/edit/${data.ticket_id}`)
              : undefined
          }
          deleteClick={canAccess ? handleDelete : undefined}
          viewClick={() => {
            setIsOpen(true)
          }}
        />
        <Button
          onClick={() => setIsChatOpen(true)}
          variant='white'
          className='p-2 position-relative'
        >
          <Image width={'20px'} height={'20px'} src={MessageIcon} />
          {data?.unseen_message_count > 0 && (
            <div
              className='bg-danger text-center'
              style={{
                position: 'absolute',
                top: 0,
                right: 0,
                color: 'white',
                height: '15px',
                width: '15px',
                borderRadius: '50%',
                fontSize: 10,
              }}
            >
              {data?.unseen_message_count}
            </div>
          )}
        </Button>
      </div>
      <ModalX
        isOpen={isOpen}
        toggle={() => setIsOpen(false)}
        size='xl'
        title={
          <h4 className={CLASSES.items_center}>
            <Image src={TicketIcon} className='me-3' />
            Ticket: {data.ticket_no}
          </h4>
        }
      >
        <TicketDetails type='modal' id={data.ticket_id} />
      </ModalX>
      <ModalX
        isOpen={isChatOpen}
        toggle={() => setIsChatOpen(false)}
        size='xl'
        title={
          <h4 className={CLASSES.items_center}>
            <Image src={TicketIcon} className='me-3' />
            Ticket: {data.ticket_no}
          </h4>
        }
      >
        {/* <Communications type='modal' id={data.ticket_id} /> */}
        <Communications
          setVisible={setIsChatOpen}
          isVisible={isChatOpen}
          ticket_id={data?.ticket_id}
          unseen_message_count={data?.unseen_message_count}
          isDisabled={
            data?.ref_ticket_status_id == TICKET_STATUS.CLOSED ||
            data?.ref_ticket_status_id == TICKET_STATUS.CANCELED
          }
        />
      </ModalX>
    </>
  )
}
